import React from 'react';

export const Icon16PXShield = (params: { fill: string; style?: React.CSSProperties }) => (
  <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg' style={params.style}>
    <g clipPath='url(#clip0_2023_37108)'>
      <path
        d='M14 26C11.1 25.3 8.71 23.7 6.83 21.22C4.94 18.73 4 15.96 4 12.92V5.6L14 2L24 5.6V12.92C24 15.96 23.06 18.73 21.17 21.22C19.28 23.71 16.89 25.3 14 26ZM14 23.48C16.17 22.82 17.96 21.5 19.38 19.52C20.8 17.54 21.5 15.34 21.5 12.92V7.25L14 4.55L6.5 7.25V12.92C6.5 15.34 7.21 17.54 8.63 19.52C10.05 21.5 11.84 22.82 14.01 23.48H14Z'
        fill={params.fill}
      />
      <path
        d='M13.9998 21.3499C12.3598 20.9199 11.0098 19.9399 9.93984 18.4199C8.86984 16.8999 8.33984 15.1999 8.33984 13.3399V8.85991L13.9998 6.65991L19.6598 8.85991V13.3399C19.6598 15.1999 19.1298 16.8899 18.0598 18.4199C16.9898 19.9399 15.6398 20.9199 13.9998 21.3499Z'
        fill={params.fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_2023_37108'>
        <rect width='20' height='24' fill='white' transform='translate(4 2)' />
      </clipPath>
    </defs>
  </svg>
);
